document.addEventListener('DOMContentLoaded', function () {
     if (document.querySelector('.product_tabs')) {
    const tabListItems = document.querySelectorAll('.tabs li');
    const contentListItems = document.querySelectorAll('.tabs-content li');

   
    if (tabListItems.length > 0) {
        
        tabListItems.forEach(tab => tab.classList.remove('active-tab'));
        tabListItems[0].classList.add('active-tab');
    }

    
    contentListItems.forEach((content, index) => {
        if (index === 0) {
            content.style.display = 'block';
        } else {
            content.style.display = 'none';
        }
    });

    
    const tabsContainer = document.querySelector('.tabs');
    if (tabsContainer) {
        tabsContainer.addEventListener('click', function (event) {
            const clickedElement = event.target.closest('.tabs li');
            
            if (clickedElement) {
                const index = Array.from(tabListItems).indexOf(clickedElement);

                if (index !== -1) {
                    
                    tabListItems.forEach(tab => tab.classList.remove('active-tab'));

                    
                    clickedElement.classList.add('active-tab');

                    
                    contentListItems.forEach((content, contentIndex) => {
                        content.style.display = (contentIndex === index) ? 'block' : 'none';
                    });
                }
            }
        });
    }
     }
});